<template>
    <div ref="dplayer"></div>
</template>

<script>
    import "hls.js"
    import DPlayer from 'dplayer'

    export default {
        components: {},
        props: ['sn'],
        data() {
            return {
                hlsUrl: '',
                chimee: undefined,
            }
        },
        computed: {},
        created() {
        },
        mounted() {
            this.player();
        },
        methods: {
            player() {
                this.$http.video.api.mega.startStream({sn: this.sn})
                    .then(res => {
                        if (res) {
                            this.hlsUrl = res.data.body.hlsUrl;
                            this.heartbeat();
                            this.dplayer = new DPlayer({
                                container: this.$refs.dplayer,
                                video: {
                                    url: this.hlsUrl,
                                    type: 'hls',
                                }
                            });
                        }
                    })
            },
            heartbeat() {
                this._timer = setInterval(this.keep, 9 * 1000)
            },
            keep() {
                this.$http.video.api.mega.keepStream({sn: this.sn})
            },
        },
        destroyed() {
            clearInterval(this._timer)
        },
    }
</script>

<style lang="less" scoped>
</style>